export default __webpack_public_path__ + "0115508b.jpg";